// import { Register } from 'pages/register';
import { Login } from '../pages/login';
import { Success } from '../pages/auth/Success';
import { Waiting } from '../pages/auth/Waiting';
import { Logout } from '../pages/logout';
import { Route } from '../types/route';

export const publicRoutes: Route[] = [
//   {
//     key: 'router-register',
//     title: 'Register',
//     description: 'Register',
//     component: Register,
//     path: '/Register',
//     isEnabled: true,
//     appendDivider: true
//   },
  {
    key: 'router-login',
    title: 'Login',
    description: 'Login',
    component: Login,
    path: '/login',
    isEnabled: true,
    appendDivider: true,
    noLayout: true
  },
  {
    key: 'router-waiting',
    title: 'Waiting',
    description: 'Waiting',
    component: Waiting,
    path: '/waiting',
    isEnabled: true,
    appendDivider: true,
    noLayout: true
  },
  {
    key: 'router-success',
    title: 'Success',
    description: 'Success',
    component: Success,
    path: '/success',
    isEnabled: true,
    appendDivider: true,
    noLayout: true
  },
  {
    key: 'router-logout',
    title: 'Logout',
    description: 'Logout',
    component: Logout,
    path: '/logout',
    isEnabled: true,
    appendDivider: true,
    noLayout: true
  },
];
